/**
 * Who may read and write an object, as Parse stores it with the object: the
 * access granted under the id of a user, under `role:<name>` to the members of
 * a role, and under `*` to everyone.
 */
export type AccessList = {
  [name: string]: { read?: boolean; write?: boolean };
};

/** The name an access list grants access to everyone under. */
const EVERYONE = "*";

/** The name an access list grants access to the members of a role under. */
export function roleName(role: string): string {
  return `role:${role}`;
}

/**
 * Whether an access list lets a user write the object: the rule Parse Server
 * applies to a save and to a delete. The user is given by the names the list
 * can know them under, their id and the {@link roleName} of each of their
 * roles. An object without an access list is open to everyone.
 */
export function canWrite(
  accessList: AccessList | undefined,
  names: string[],
): boolean {
  if (!accessList) return true;
  if (accessList[EVERYONE]?.write) return true;
  return names.some((name) => accessList[name]?.write);
}
